import React from 'react';

const stories = [
    {
        id: 1,
        icon: '🔒',
        tag: '隐私安全',
        title: '家族专属，真实信任',
        points: [
            '严格保护账号与家庭隐私，用户自主掌控权限。',
            '真人实名，信任社交，让您的数据安全真实可靠。',
        ],
        gradient: 'from-green-500 to-emerald-600',
        bg: 'from-white to-green-50',
        border: 'border-green-100',
        hover: 'from-green-500/5 to-emerald-500/5',
        badge: 'bg-green-100 text-green-700',
        dot: 'bg-green-400',
        bar: 'from-green-400 to-emerald-500',
        titleGradient: 'from-green-600 to-emerald-700',
    },
    {
        id: 2,
        icon: '💾',
        tag: '技术坚守',
        title: '珍贵回忆，不因时间遗失',
        points: [
            '构建高性能、易使用、更安全的「族语」技术体系，',
            '无论多久以后，那些重要瞬间依然清晰可见。',
        ],
        gradient: 'from-blue-500 to-indigo-600',
        bg: 'from-white to-blue-50',
        border: 'border-blue-100',
        hover: 'from-blue-500/5 to-indigo-500/5',
        badge: 'bg-blue-100 text-blue-700',
        dot: 'bg-blue-400',
        bar: 'from-blue-400 to-indigo-500',
        titleGradient: 'from-blue-600 to-indigo-700',
    },
    {
        id: 3,
        icon: '👨‍👩‍👧‍👦',
        tag: '家人共享',
        title: '让陪伴，不受时空限制',
        points: [
            '不受时空限制，家人共同参与记录与查看。',
            '成长不再是一个人的记忆，而是全家一起见证的故事。',
        ],
        gradient: 'from-purple-500 to-pink-600',
        bg: 'from-white to-purple-50',
        border: 'border-purple-100',
        hover: 'from-purple-500/5 to-pink-500/5',
        badge: 'bg-purple-100 text-purple-700',
        dot: 'bg-purple-400',
        bar: 'from-purple-400 to-pink-500',
        titleGradient: 'from-purple-600 to-pink-700',
    },
    {
        id: 4,
        icon: '🌱',
        tag: '持续成长',
        title: '族语与您一起成长',
        points: [
            '倾听用户需求，持续优化体验与功能。',
            '族语不是"做完的产品"，而是持续优化的亲情社交平台。',
        ],
        gradient: 'from-orange-500 to-amber-600',
        bg: 'from-white to-orange-50',
        border: 'border-orange-100',
        hover: 'from-orange-500/5 to-amber-500/5',
        badge: 'bg-orange-100 text-orange-700',
        dot: 'bg-orange-400',
        bar: 'from-orange-400 to-amber-500',
        titleGradient: 'from-orange-600 to-amber-700',
    },
];

const ProductStory = () => {
    return (
        <div id="portfolio" className="bg-gradient-to-br from-slate-50 to-blue-50 py-16 md:py-24">
            <section>
                <div className="container mx-auto px-4 md:px-8">
                    {/* 标题区域 */}
                    <div className="text-center mb-16">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                            <span className="text-2xl">📖</span>
                        </div>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
                            为什么选择<span className="text-blue-600">族语</span>？
                        </h2>
                        <div className="w-20 h-1 bg-blue-600 mx-auto mb-6 rounded-full"></div>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                            族语留住一家人的故事，也守住一家人的隐私。
                        </p>
                    </div>

                    {/* 故事卡片 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
                        {stories.map((story, index) => (
                            <div
                                key={story.id}
                                className={`group relative bg-gradient-to-br ${story.bg} rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border ${story.border}`}
                            >
                                <div className={`absolute inset-0 bg-gradient-to-br ${story.hover} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>

                                <div className="p-7 relative">
                                    <div className="flex items-start gap-4 mb-6">
                                        <div className={`w-14 h-14 bg-gradient-to-br ${story.gradient} rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform duration-300 shadow-md flex-shrink-0`}>
                                            <span className="text-2xl text-white">{story.icon}</span>
                                        </div>
                                        <div>
                                            <div className={`inline-block ${story.badge} text-sm font-medium px-3 py-1 rounded-full mb-2`}>
                                                {story.tag}
                                            </div>
                                            <h3 className={`text-xl md:text-2xl font-bold bg-gradient-to-r ${story.titleGradient} bg-clip-text text-transparent leading-tight`}>
                                                {story.title}
                                            </h3>
                                        </div>
                                    </div>

                                    <div className="space-y-3">
                                        {story.points.map((point, i) => (
                                            <div key={i} className="flex items-start gap-3">
                                                <div className={`w-2 h-2 ${story.dot} rounded-full mt-2 flex-shrink-0`}></div>
                                                <p className="text-gray-700 leading-relaxed">{point}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className={`absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r ${story.bar} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProductStory;
